import Swal from "sweetalert2";

const ConfirmationSwal = Swal.mixin({
  confirmButtonColor: "#3182CE",
  reverseButtons: true,
  showCancelButton: true,
  showCloseButton: true,
});

export default ConfirmationSwal;
